import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useTagSectionHttp } from '@/core/api/tag-sections'
import { TagSection, TagSectionPayload } from '@/core/models/tag-section'

export type TagSectionCollection = {
    data: Array<TagSection>,
    meta?: MetaPayload,
    links?: any
}

const state: TagSectionCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const tagSectionCollection: Module<TagSectionCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: TagSectionCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: TagSectionPayload) => {
                state.data.push(new TagSection(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useTagSectionHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: TagSectionCollection): TagSectionCollection => {
            return state
        }
    }
}
